import { Button, Colors } from '@gripp/shared-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

export const ViewAllSectionHeader: React.FC<{
  title: string;
  onPress: () => void;
  disabled?: boolean;
}> = ({ title, onPress, disabled }) => {
  const { t } = useTranslation();

  return (
    <View style={styles.listHeaderContainerCropCircle}>
      <Text style={styles.sectionTitleCropCircle}>{title}</Text>
      <Button onPress={onPress} style={styles.viewAllButton} disabled={disabled}>
        <Text style={styles.viewAllButtonLabelCropCircle}>
          {t(`activity.header.viewAll`)}
        </Text>
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  listHeaderContainerCropCircle: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    height: 20,
  },
  sectionTitleCropCircle: {
    textAlignVertical: 'top',
    fontSize: 16,
    fontWeight: '600',
    color: Colors.black,
  },
  viewAllButton: {
    backgroundColor: Colors.secondaryContainer,
  },
  viewAllButtonLabelCropCircle: {
    fontSize: 14,
    fontWeight: '400',
    color: Colors.slate[400],
    lineHeight: 18,
  },
});
